import React, { FC } from 'react';

import classNames from 'classnames';

import { EvSkeleton } from '@evinced-private/ui-common';

import './WfaSessionOverviewSkeleton.scss';

interface WfaSessionOverviewSkeletonProps {
	isAnimated?: boolean;
	isOverlay?: boolean;
}

export const WfaSessionOverviewSkeleton: FC<WfaSessionOverviewSkeletonProps> = ({
	isAnimated = true,
	isOverlay = false
}) => {
	const animationSpeed = isAnimated ? undefined : 0;

	return (
		<div
			className={classNames('wfa-session-overview-skeleton', {
				'wfa-session-overview-skeleton--overlay': isOverlay
			})}
		>
			{/* Header Section */}
			<div className="skeleton-header">
				<div className="skeleton-title-row">
					<div className="skeleton-title">
						<EvSkeleton height="28px" width="200px" animationSpeed={animationSpeed} />
					</div>
					<div className="skeleton-actions">
						<EvSkeleton height="32px" width="32px" animationSpeed={animationSpeed} />
						<EvSkeleton height="32px" width="32px" animationSpeed={animationSpeed} />
					</div>
				</div>

				{/* ReportInfo Skeleton */}
				<div className="skeleton-info-section">
					<div className="skeleton-info-items">
						<div className="skeleton-data-item">
							<EvSkeleton height="46px" width="142px" animationSpeed={animationSpeed} />
						</div>
						<div className="skeleton-data-item">
							<EvSkeleton height="46px" width="90px" animationSpeed={animationSpeed} />
						</div>
						<div className="skeleton-data-item">
							<EvSkeleton height="46px" width="60px" animationSpeed={animationSpeed} />
						</div>
					</div>
				</div>
			</div>

			{/* Tabs Skeleton */}
			<div className="skeleton-tabs">
				<EvSkeleton height="24px" width="80px" animationSpeed={animationSpeed} />
				<EvSkeleton height="24px" width="100px" animationSpeed={animationSpeed} />
				<EvSkeleton height="24px" width="80px" animationSpeed={animationSpeed} />
			</div>

			{/* Content Section */}
			<div className="skeleton-overview-content">
				{/* Summary Pane Skeleton */}
				<div className="skeleton-summary-pane">
					<EvSkeleton height="47px" width="70px" animationSpeed={animationSpeed} />
					<EvSkeleton height="47px" width="80px" animationSpeed={animationSpeed} />
					<EvSkeleton height="47px" width="36px" animationSpeed={animationSpeed} />
				</div>

				{/* Issue Types Chart Skeleton */}
				<div className="skeleton-chart-section">
					<EvSkeleton height="595px" width="100%" animationSpeed={animationSpeed} />
				</div>

				{/* Bottom Charts Skeleton */}
				<div className="skeleton-bottom-charts">
					<div className="skeleton-chart-col">
						<EvSkeleton height="595px" width="100%" animationSpeed={animationSpeed} />
					</div>
					<div className="skeleton-chart-col">
						<EvSkeleton height="595px" width="100%" animationSpeed={animationSpeed} />
					</div>
				</div>
			</div>
		</div>
	);
};
